import { withStyles } from '@material-ui/styles';
import TableCell from '@material-ui/core/TableCell';

const TableCellHeaderBasic = withStyles(() => ({
  head: {
    color: 'white',
    background: '#3b86eb',
  },
  body: {
    fontSize: 14,
    fontWeight: 'bold',
  },
}))(TableCell);

export default TableCellHeaderBasic;
